export const TypeAngles = {
    "Tipo B": 60,
    "Tipo A": 60,
    "Etapa 1": 20,
}